import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { Providers } from "./lib/store";
import SiteLayout from "./components/site/Layout";
import Home from "./pages/Home";
import Catalog from "./pages/Catalog";
import ArtworkDetail from "./pages/ArtworkDetail";
import { Artists, ArtistDetail, Venues, VenueDetail } from "./pages/People";
import { Finds, FindDetail, Interior, Events, EventDetail } from "./pages/Offers";
import { About, Contact, Apply, Legal, QrResolve, NotFound } from "./pages/Info";
import { Cart, PaymentSuccess, PaymentCancel, OrderView } from "./pages/Shop";
import { Login, SetPassword } from "./pages/AuthPages";
import AdminLayout from "./admin/AdminLayout";
import EntityManager from "./admin/EntityManager";
import { Dashboard, Inquiries, InquiryDetail, Orders, OrderDetail, PrintJobs } from "./admin/Ops";
import { Finance, Memberships, QrAdmin, QrLabel } from "./admin/Finance";
import { HeroEditor, SocialStudio } from "./admin/Studio";
import { Users, Settings, Mail, Data, Profile } from "./admin/System";
import { VenueSelection, PlacementDetail, MaterialPrint, PrintRequests, Editions, Certificate, Promotions } from "./admin/Partner";
import { Suggestions, ShareKit, ContentHub, Terms, PromoPackages, Split, MyPlan } from "./admin/Growth";
import Invite from "./pages/Invite";
import GeorgeWelcome from "./admin/GeorgeWelcome";
import CollaboratorWelcome from "./admin/CollaboratorWelcome";
import { PilotInbox } from "./admin/PilotWelcome";
import PersonalPages from "./admin/PersonalPages";

export default function App() {
  return (
    <Providers>
      <BrowserRouter>
        <Routes>
          <Route element={<SiteLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/kunst" element={<Catalog />} />
            <Route path="/kunst/:slug" element={<ArtworkDetail />} />
            <Route path="/prints" element={<Catalog printsOnly />} />
            <Route path="/prints/:slug" element={<ArtworkDetail printFocus />} />
            <Route path="/kuenstler" element={<Artists />} />
            <Route path="/kuenstler/:slug" element={<ArtistDetail />} />
            <Route path="/lokale" element={<Venues />} />
            <Route path="/lokale/:slug" element={<VenueDetail />} />
            <Route path="/fundstuecke" element={<Finds />} />
            <Route path="/fundstuecke/:slug" element={<FindDetail />} />
            <Route path="/einrichtung" element={<Interior />} />
            <Route path="/vernissagen" element={<Events />} />
            <Route path="/vernissagen/:slug" element={<EventDetail />} />
            <Route path="/ueber-uns" element={<About />} />
            <Route path="/kontakt" element={<Contact />} />
            <Route path="/bewerbung/:kind" element={<Apply />} />
            <Route path="/rechtliches/:slug" element={<Legal />} />
            <Route path="/warenkorb" element={<Cart />} />
            <Route path="/zahlung/erfolg" element={<PaymentSuccess />} />
            <Route path="/zahlung/abbruch" element={<PaymentCancel />} />
            <Route path="/bestellung/:id" element={<OrderView />} />
            <Route path="/q/:code" element={<QrResolve />} />
            <Route path="/lokal-einladung/:token" element={<Invite />} />
            <Route path="/login" element={<Login />} />
            <Route path="/passwort-zuruecksetzen" element={<SetPassword />} />
            <Route path="/einladung" element={<SetPassword invite />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route path="/admin/etikett/:id" element={<QrLabel />} />
          <Route path="/admin/material/:id" element={<MaterialPrint />} />
          <Route path="/admin/zertifikat/:id" element={<Certificate />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<Dashboard />} />
            <Route path="startseiten" element={<PersonalPages />} />
            <Route path="gesamt" element={<Dashboard full />} />
            <Route path="george-start" element={<GeorgeWelcome />} />
            <Route path="pilot-rueckmeldungen" element={<PilotInbox />} />
            <Route path="martin-start" element={<CollaboratorWelcome person="martin" />} />
            <Route path="lori-start" element={<CollaboratorWelcome person="lori" />} />
            <Route path="maya-start" element={<CollaboratorWelcome person="maya" />} />
            <Route path="joachim-start" element={<CollaboratorWelcome person="joachim" />} />
            <Route path="anfragen" element={<Inquiries />} />
            <Route path="anfragen/:id" element={<InquiryDetail />} />
            <Route path="bestellungen" element={<Orders />} />
            <Route path="bestellungen/:id" element={<OrderDetail />} />
            <Route path="druck" element={<PrintJobs />} />
            <Route path="abrechnung" element={<Finance />} />
            <Route path="mitgliedschaften" element={<Memberships />} />
            <Route path="qr" element={<QrAdmin />} />
            <Route path="hero" element={<HeroEditor />} />
            <Route path="social" element={<SocialStudio />} />
            <Route path="nutzer" element={<Users />} />
            <Route path="einstellungen" element={<Settings />} />
            <Route path="mail" element={<Mail />} />
            <Route path="daten" element={<Data />} />
            <Route path="profil" element={<Profile />} />
            <Route path="lokal-auswahl" element={<VenueSelection />} />
            <Route path="platzierung/:id" element={<PlacementDetail />} />
            <Route path="druckanfragen" element={<PrintRequests />} />
            <Route path="editionen" element={<Editions />} />
            <Route path="promotion" element={<Promotions />} />
            <Route path="lokalvorschlaege" element={<Suggestions />} />
            <Route path="teilen" element={<ShareKit />} />
            <Route path="content" element={<ContentHub />} />
            <Route path="konditionen" element={<Terms />} />
            <Route path="promotionspakete" element={<PromoPackages />} />
            <Route path="aufteilung" element={<Split />} />
            <Route path="paket" element={<MyPlan />} />
            <Route path="e/:entity" element={<EntityManager />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" />
    </Providers>
  );
}




